import Cookies from "universal-cookie";

export default function removeCookie(name: string): void {
  new Cookies().remove(name);
}
